// extracted by mini-css-extract-plugin
export default {"actuality":"styles_actuality__pnNMq","blue":"styles_blue__cU2d+","white":"styles_white__A9Gc1"};